import { useMutation, useQuery } from '@tanstack/react-query'
import { fetchSupportPrefill, submitSupportForm } from '../api/support'
import { queryKeys } from '../api/queryKeys'
import type { SupportFormValues } from '../api/support'

export function useSupportPrefill(userId: string) {
  return useQuery({
    queryKey: queryKeys.support.prefill(userId),
    queryFn: () => fetchSupportPrefill(userId),
    enabled: !!userId,
  })
}

export function useSubmitSupportFormMutation() {
  return useMutation({
    mutationFn: (values: SupportFormValues) => submitSupportForm(values),
  })
}
